import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  FormControlLabel,
  Checkbox,
  Menu,
  Card,
  CardContent,
  Divider,
  alpha,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { showToast, WEBSERVICE } from "../../../CoreDataService";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { use } from "react";
import CustomCircleCheck from "../../../Common/CircleCheck";
import { ContainedButton, OutlinedButton } from "../../../Common/Buttons";

// ─── Design-system style objects ────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflowX: "auto",
  backgroundColor: "var(--body-color-less)",
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "85%", sm: 440 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.15rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
};

// ─── Feature bullets shown inside the hero ──────────────────────────────────

const FEATURE_BULLETS = [
  "Repay any time",
  "No transaction fees",
  "No credit check required",
  "Earn Interest collaterals supported",
];

// ────────────────────────────────────────────────────────────────────────────

const CryptoLoans = () => {
  const navigate = useNavigate();
  const { btncolor, allColors } = useSelector((state) => state);
  const theme = localStorage.getItem("theme") || "dark";
  const [showFlexibleCols, setShowFlexibleCols] = useState(true);
  const [showStableCols, setShowStableCols] = useState(true);
  const [loanAssets, setLoanAssets] = useState([]);
  const accessToken = localStorage.getItem("access_token");
  const [isFlexibleExpanded, setFlexibleExpanded] = useState(false);
  const [is30DaysExpanded, set30DaysExpanded] = useState(false);
  const ASSETICONBASEURL =
    "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/";
  // const currencies = ['USDT', 'BTC', 'ETH', 'BNB', 'XRP']; // example currencies
  const [selectedLoanType, setSelectedLoanType] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [selectedCurrencyForCollateral, setSelectedCurrencyForCollateral] =
    useState({ name: "" });
  const [anchorBorrow, setAnchorBorrow] = useState(null);
  const [anchorCollateral, setAnchorCollateral] = useState(null);
  const [collateralAmount, setCollateralAmount] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [balanceType, setBalanceType] = useState("");
  const [borrowModalOpen, setBorrowModalOpen] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrencyForBorrow, setSelectedCurrencyForBorrow] = useState({
    name: "",
  });
  const { brokerBasicInfo } = useSelector((state) => state);
  const [loanDetails, setLoanDetails] = useState({
    spotWallet: 0.0,
    earnWallet: 0.0,
    totalBalance: 0.0,
    annualBorrowRate: 0.0,

    netAnnualRate: 0.0,
    ratePerMinute: 0.0,
    liquidationPrice: 0.0,
    initialLTV: 0.0,
    liquidationLTV: 0.0,
    marginCallLTV: 0.0,
    minimumCollateral: 0.0,
    earnWalletBalance: 0.0,
    totalBalance: 0.0,
  });

  const [showSpotWalletBalance, setShowSpotWalletBalance] = useState(false);
  const [showEarnWalletBalance, setShowEarnWalletBalance] = useState(false);
  const [showTotalBalance, setShowTotalBalance] = useState(false);
  const [showMinimumLoanableAmount, setShowMinimumLoanableAmount] =
    useState(false);
  const [showBalance, setShowBalance] = useState(false);
  const [selectedAssetForLoan, setSelectedAssetForLoan] = useState({});
  const [
    annualizedBorrowInterestRateForPopup,
    setAnnualizedBorrowInterestRateForPopup,
  ] = useState(0);
  const [interestRatePerMinuteForPopup, setInterestRatePerMinuteForPopup] =
    useState(0);

  const [initialLTVForPopup, setInitialLTVForPopup] = useState(0);
  const [liquidationLTVForPopup, setLiquidationLTVForPopup] = useState(0);
  const [marginCallLTVForPopup, setMarginCallLTVForPopup] = useState(0);
  const [selectedBalanceType, setSelectedBalanceType] = useState("");
  const [isBorrowDropdownExpanded, setIsBorrowDropdownExpanded] =
    useState(false);
  const [isCollateralDropdownExpanded, setIsCollateralDropdownExpanded] =
    useState(false);
  const [currencyBackup, setCurrencyBackup] = useState([]);
  const [minimumCollateralAmountForPopup, setMinimumCollateralAmountForPopup] =
    useState(0);
  const [spotWalletBalanceForPopup, setSpotWalletBalanceForPopup] = useState(0);
  const [earnWalletBalanceForPopup, setEarnWalletBalanceForPopup] = useState(0);
  const [totalBalanceForPopup, setTotalBalanceForPopup] = useState(0);
  const [liquidationPriceForPopup, setLiquidationPriceForPopup] = useState(0);
  const [createLoanPayloadStatus, setCreateLoanPayloadStatus] = useState("");
  const [ltpOfLoanableAsset, setLtpOfLoanableAsset] = useState(0);
  const [ltpOfCollateralAsset, setLtpOfCollateralAsset] = useState(0);
  const [
    netAnnualizedInterestRateForPopup,
    setNetAnnualizedInterestRateForPopup,
  ] = useState(0);

  const [minLoanableAmount, setMinLoanableAmount] = useState(0);
  const [showMinimumCollateralAmount, setShowMinimumCollateralAmount] =
    useState(false);

  const handleBorrowClick = (event) => setAnchorBorrow(event.currentTarget);
  const handleCollateralClick = (event) =>
    setAnchorCollateral(event.currentTarget);

  const [showCollateralInfo, setShowCollateralInfo] = useState(false);
  const [
    showAnnualizedBorrowInterestRateInfo,
    setShowAnnualizedBorrowInterestRateInfo,
  ] = useState(false);
  const [showAnnualizedInterestRateInfo, setShowAnnualizedInterestRateInfo] =
    useState(false);
  const [showLiquidationRateInfo, setShowLiquidationRateInfo] = useState(false);
  const [showLiquidationPriceInfo, setShowLiquidationPriceInfo] =
    useState(false);
  const [showInitialLtvInfo, setShowInitialLtvInfot] = useState(false);
  const [showLiqudationLtvInfo, setShowLiqudationLtvInfo] = useState(false);
  const [showMarginCallLtvInfo, setShowMarginCallLtvInfo] = useState(false);
  const [loanInfoModal, setLoanInfoModal] = useState(false);
  const [loanServiceAgreement, setLoanAgreement] = useState(
    window.location.origin + "/legal/loan-users.html"
  );
  const [earnAgreement, setEarnAgreement] = useState(
    window.location.origin + "/legal/earn-product-users.html"
  );

  const handleBorrowCurrencySelect = (currency) => {
    // console.log('currency',currency);

    setSelectedCurrencyForBorrow(currency);
    setAnchorBorrow(null);
    if (currency === selectedCurrencyForCollateral.name) {
      setSelectedCurrencyForCollateral(""); // reset if both are same
    }
    console.log("tesr");
  };

  const handleCollateralCurrencySelect = (currency) => {
    setSelectedCurrencyForCollateral(currency);
    setAnchorCollateral(null);
  };

  console.log(
    "selectedCurrencyForCollateral",
    selectedCurrencyForCollateral,
    selectedCurrencyForBorrow
  );

  const getAllLoanAssets = async () => {
    try {
      const response = await axios.get(
        `/crypto/banking/loan/getLoanMarketDetails/${localStorage.getItem("BROKERID")}`,
        {
          baseURL: WEBSERVICE, // or replace with your base URL
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) {
        document.body.classList.remove("overlay");
        alert(result.error.error_msg || "Error fetching data");
        return;
      }

      const loanMarketDetails = result.loanMarketDetails || [];
      const loanAssetsMap = new Map();

      loanMarketDetails.forEach((item) => {
        const key = item.loanAsset;
        if (!loanAssetsMap.has(key)) {
          loanAssetsMap.set(key, {
            customerId: item.customerId,
            loanAsset: item.loanAsset,
            collateralAsset: item.collateralAsset,
          });
        }

        const asset = loanAssetsMap.get(key);

        const rateInfo = {
          loanDurationId: item.loanDurationId,
          interestRatePerMinute: item.interestRatePerMinute,
          annualizedInterestRate: item.annualizedInterestRate,
          minLoanableAmount: item.minLoanableAmount,
          maxCumulativeBorrowAmountUSD: item.maxCumulativeBorrowAmountUSD,
          initialLTV: item.initialLTV,
          liquidationLTV: item.liquidationLTV,
          marginCallLTV: item.marginCallLTV,
        };

        if (item.loanDurationId === 1) {
          asset.flexibleRate = rateInfo;
        } else if (item.loanDurationId === 2) {
          asset.sevenDaysRate = rateInfo;
        } else if (item.loanDurationId === 3) {
          asset.thirtyDaysRate = rateInfo;
        }

        loanAssetsMap.set(key, asset);
      });

      const uniqueLoanAssets = Array.from(loanAssetsMap.values());
      setLoanAssets(uniqueLoanAssets);
      console.log("loanAssets:", uniqueLoanAssets);

      // getAllCurrencyList();

      //   getAllCurrencyList(); // You can implement this separately
    } catch (error) {
      document.body.classList.remove("overlay");
      const status = error.response?.status;

      if (status === 401) {
        // logout and alert
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
        // //logout // Implement this function
      } else if (![200, 429, 403].includes(status)) {
        // optional error alert
        // alert(error.message);
      }
    }
  };

  const getAllCurrencyList = () => {
    const currencyList = loanAssets.map((asset) => asset.loanAsset);
    const uniqueCurrencies = Array.from(new Set(currencyList));

    console.log("uniqueCurrencies", uniqueCurrencies);

    setCurrencies(uniqueCurrencies);
    // setSelectedCurrencyForBorrow(uniqueCurrencies[0])

    setCurrencyBackup(uniqueCurrencies);
  };

  const handleOpenBorrowModal = (param) => {
    setLoanDetails({
      spotWallet: 0.0,
      earnWallet: 0.0,
      totalBalance: 0.0,
      annualBorrowRate: 0.0,
      netAnnualRate: 0.0,
      ratePerMinute: 0.0,
      liquidationPrice: 0.0,
      initialLTV: 0.0,
      liquidationLTV: 0.0,
      marginCallLTV: 0.0,
      minimumCollateral: 0.0,
      earnWalletBalance: 0.0,
      totalBalance: 0.0,
    });

    setSelectedAssetForLoan(param);

    // Select loan and collateral currencies
    handleSelectBorrowCurrency(param.loanAsset);
    if (param.loanAsset !== "ETH") {
      handleSelectCollateralCurrency("ETH");
    } else {
      handleSelectCollateralCurrency("BTC");
    }

    // Reset form inputs
    setSelectedLoanType("");
    setLoanAmount("");
    setCollateralAmount("");
    setAgreeTerms(false);
    setBalanceType("");

    // Reset flags and visibility states
    setShowSpotWalletBalance(false);
    setShowEarnWalletBalance(false);
    setShowTotalBalance(false);
    setShowMinimumLoanableAmount(false);
    setShowBalance(false);

    // Open the modal
    setBorrowModalOpen(true);
  };

  const handleSelectCollateralCurrency = (param) => {
    setLoanAmount(""); // Reset loan amount on currency change
    setCollateralAmount(""); // Reset collateral amount on currency change
    setSelectedCurrencyForCollateral({ name: param });
    // getLiquidationPrice(
    //   "collateral",
    //   0,
    //   selectedCurrencyForBorrow?.name,
    //   param
    // );
  };

  useEffect(() => {
    if (selectedAssetForLoan) {
      renderDataOnBasisOfLoanType("");
    }
  }, [selectedAssetForLoan]);

  const handleSelectBorrowCurrency = (param) => {
    console.log("param", param);
    setLoanAmount(""); // Reset loan amount on currency change
    setCollateralAmount(""); // Reset collateral amount on currency change
    setSelectedCurrencyForBorrow({ name: param });
    // getLiquidationPrice("loan", 0, param, selectedCurrencyForCollateral?.name);

    const filteredCurrencies = currencies.filter((item) => item !== param);
    setCurrencyBackup(filteredCurrencies);
  };

  const renderDataOnBasisOfLoanType = (val) => {
    setSelectedLoanType(val);
    console.log("selectedAssetForLoan", val);
    let rateDetails;
    setLoanAmount("");
    setCollateralAmount("");
    setShowMinimumLoanableAmount(() => false);
    setShowMinimumCollateralAmount(() => false);

    if (val === "1") {
      rateDetails = selectedAssetForLoan.flexibleRate;
      setSelectedBalanceType("");
      setShowSpotWalletBalance(true);
      setShowEarnWalletBalance(true);
      setShowTotalBalance(true);
    } else if (val === "2") {
      rateDetails = selectedAssetForLoan.sevenDaysRate;
      setSelectedBalanceType("SPOT_WALLET");
      setShowSpotWalletBalance(true);
      setShowEarnWalletBalance(false);
      setShowTotalBalance(false);
    } else if (val === "3") {
      rateDetails = selectedAssetForLoan.thirtyDaysRate;
      setInterestRatePerMinuteForPopup(rateDetails.interestRatePerMinute);
      setSelectedBalanceType("SPOT_WALLET");
      setShowSpotWalletBalance(true);
      setShowEarnWalletBalance(false);
      setShowTotalBalance(false);
    }

    if (rateDetails) {
      setAnnualizedBorrowInterestRateForPopup(
        rateDetails.annualizedInterestRate
      );
      setMinLoanableAmount(rateDetails.minLoanableAmount);
      setInitialLTVForPopup(rateDetails.initialLTV);
      setLiquidationLTVForPopup(rateDetails.liquidationLTV);
      setMarginCallLTVForPopup(rateDetails.marginCallLTV);
    }

    console.log(minLoanableAmount);
    // getLiquidationPrice("loan");
  };

  const getLiquidationPrice = async (
    type,
    val,
    loanableAsset,
    collateralAsset
  ) => {
    console.log("loanamountttt", val);
    if (val <= 0) {
      showToast("error", "Amount should be greater than 0");
      return;
    }
    let isCallAPI = false;
    if (
      type === "loan" &&
      val !== ""
      // parseFloat(val) >= parseFloat(minLoanableAmount)
    ) {
      isCallAPI = true;
    } else if (
      type === "collateral" &&
      val !== ""
      // parseFloat(val) >= parseFloat(minimumCollateralAmountForPopup)
    ) {
      isCallAPI = true;
    }

    if (!isCallAPI) return;

    const payload = {
      loanableAsset: loanableAsset,
      collateralAsset: collateralAsset,
      uuid: localStorage.getItem("uuid"),
      ...(type === "loan"
        ? { borrowingAmount: val }
        : { collateralAmount: val }),
      loanType:
        selectedLoanType === "1"
          ? "Flexible"
          : selectedLoanType === "2"
          ? "7"
          : "30",
    };

    console.log("payload", payload);

    try {
      const response = await fetch(
        `${WEBSERVICE}crypto/banking/loan/calculateLoanPriceCollAmount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.error.error_data !== 0) {
        document.body.classList.remove("overlay");
        showToast("error", result.error.error_msg);
        return;
      }

      const details = result.borrowCalculateDetails;

      setSpotWalletBalanceForPopup(details.spotBalance);
      setEarnWalletBalanceForPopup(details.redeemableBlance);
      setTotalBalanceForPopup(details.totalBalane);

      if (type === "loan") {
        setCollateralAmount(details.collateralAmount);
      } else {
        setLoanAmount(details.borrowingAmount);
      }

      setInterestRatePerMinuteForPopup(details.approxRatePerMiniute);
      setLiquidationPriceForPopup(details.liquidationPrice);
      setMinimumCollateralAmountForPopup(details.minCollateralAmount);
      setCreateLoanPayloadStatus(type);
      setLtpOfLoanableAsset(details.ltpBorrowingAsset);
      setLtpOfCollateralAsset(details.ltpCollateralAsset);
      setMinLoanableAmount(details.minLoanableAmount);
      setNetAnnualizedInterestRateForPopup(details.netAnnualizedInterestRate);

      showHideBalance();
      // showHideMinimumLoanableAmount();
    } catch (error) {
      document.body.classList.remove("overlay");
      if ([401, 400, 403].includes(error?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  useEffect(() => {
    if (!balanceType) {
      if (showSpotWalletBalance) {
        setBalanceType("SPOT_WALLET");
        setSelectedBalanceType("SPOT_WALLET");
      } else if (showEarnWalletBalance) {
        setBalanceType("EARN_WALLET");
        setSelectedBalanceType("EARN_WALLET");
      } else if (showTotalBalance) {
        setBalanceType("TOTAL_WALLET");
        setSelectedBalanceType("TOTAL_WALLET");
      }
    }
  }, [
    balanceType,
    showSpotWalletBalance,
    showEarnWalletBalance,
    showTotalBalance,
  ]);

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const showHideMinimumLoanableAmount = () => {
    if (loanAmount !== "") {
      console.log(loanAmount, minLoanableAmount, ltpOfLoanableAsset);

      const loanAmountValue = parseFloat(loanAmount);
      const minLoanAmountInAsset =
        parseFloat(minLoanableAmount) / parseFloat(ltpOfLoanableAsset);

      if (loanAmountValue < parseFloat(minLoanableAmount)) {
        setShowMinimumLoanableAmount(true);
      } else {
        setShowMinimumLoanableAmount(false);
      }
    }

    if (collateralAmount !== "") {
      const showMinLoan =
        parseFloat(loanAmount) <=
          parseFloat(minLoanableAmount) / parseFloat(ltpOfLoanableAsset) ||
        parseFloat(loanAmount) <= parseFloat(minLoanableAmount);

      if (
        parseFloat(collateralAmount) <
        parseFloat(minimumCollateralAmountForPopup)
      ) {
        setShowMinimumCollateralAmount(true);
      } else {
        setShowMinimumCollateralAmount(false);
      }
    }
  };
  const showHideBalance = () => {
    let shouldShow = false;

    if (selectedBalanceType !== "" && loanAmount !== "") {
      const loan = parseFloat(loanAmount);

      if (
        (selectedBalanceType === "SPOT_WALLET" &&
          loan > parseFloat(spotWalletBalanceForPopup)) ||
        (selectedBalanceType === "EARN_WALLET" &&
          loan > parseFloat(earnWalletBalanceForPopup)) ||
        (selectedBalanceType === "TOTAL_WALLET" &&
          loan > parseFloat(totalBalanceForPopup))
      ) {
        shouldShow = true;
      }
    }

    setShowBalance(shouldShow);
  };

  useEffect(() => {
    getAllLoanAssets();
  }, []);

  useEffect(() => {
    getAllCurrencyList();
  }, [loanAssets]);

  useEffect(() => {
    if (loanAmount !== "" && ltpOfLoanableAsset > 0 && minLoanableAmount > 0) {
      showHideMinimumLoanableAmount();
    }
  }, [
    loanAmount,
    collateralAmount,
    ltpOfLoanableAsset,
    minLoanableAmount,
    minimumCollateralAmountForPopup,
  ]);

  const getMaxCollateralAmount = async () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    console.log("selectedCurrencyForCollateral", selectedCurrencyForCollateral);

    const payload = {
      uuid: uuid,
      currency: selectedCurrencyForCollateral.name,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/loan/getMaxCollateralAmount`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) {
        showToast("error", result.error.error_msg); // Using toast for alerts
      } else {
        setCollateralAmount(result.maxCollateralAmount[0].currentBalance);
      }

      getLiquidationPrice(
        "collateral",
        collateralAmount,
        selectedCurrencyForBorrow?.name,
        selectedCurrencyForCollateral?.name
      ); // Assuming this is defined elsewhere
    } catch (error) {
      if ([400, 401, 403].includes(error.response?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const handleGetLoan = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid: uuid,
      loanableAsset: selectedCurrencyForBorrow.name,
      collateralAsset: selectedCurrencyForCollateral.name,
      balanceType: selectedBalanceType,
      // borrowingAmount: loanAmount,
      // collateralAmount: 0,
    };

    if (createLoanPayloadStatus === "loan") {
      payload.borrowingAmount = loanAmount;
      payload.collateralAmount = 0;
    } else {
      payload.borrowingAmount = 0;
      payload.collateralAmount = collateralAmount;
    }

    if (selectedLoanType === "1") {
      payload.loanType = "Flexible";
    } else if (selectedLoanType === "2") {
      payload.loanType = "7";
    } else if (selectedLoanType === "3") {
      payload.loanType = "30";
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/loan/createLoan`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + token,
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        showToast("success", result.error.error_msg);
        getAllCurrencyList();
        getAllLoanAssets();
        setBorrowModalOpen(false);
      }
    } catch (error) {
      console.log("errorrrr", error);
      if ([401, 403].includes(error.response?.status)) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        logout();
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const resetAndCloseLoanInfoModal = () => {
    setShowCollateralInfo(false);
    setShowAnnualizedBorrowInterestRateInfo(false);
    setShowAnnualizedInterestRateInfo(false);
    setShowLiquidationRateInfo(false);
    setShowLiquidationPriceInfo(false);
    setShowInitialLtvInfot(false);
    setShowLiqudationLtvInfo(false);
    setShowMarginCallLtvInfo(false);
    setLoanInfoModal(false);
  };

  const openInfoModal = () => {
    setLoanInfoModal(true);
  };

  const dataItems = [
    {
      label: "Annualized Borrow Interest Rate (%)",
      tooltip:
        "This is the yearly interest rate you'd be charged for borrowing.",
      value: annualizedBorrowInterestRateForPopup,
      onClick: () => {
        setShowAnnualizedBorrowInterestRateInfo(true);
        openInfoModal();
      },
    },
    {
      label: "Net Annualized Interest Rate (%)",
      tooltip: "Net yearly interest rate after all adjustments.",
      value: netAnnualizedInterestRateForPopup,
      onClick: () => {
        setShowAnnualizedInterestRateInfo(true);
        openInfoModal();
      },
    },
    {
      label: "Estimated Interest Rate Per Minute",
      tooltip: "Approximate interest rate calculated per minute.",
      value: interestRatePerMinuteForPopup,
      onClick: () => {
        setShowLiquidationRateInfo(true);
        openInfoModal();
      },
    },
    {
      label: "Liquidation Price (USD)",
      tooltip: "Price at which your collateral will be liquidated.",
      value: `${liquidationPriceForPopup} USD`,
      onClick: () => {
        setShowLiquidationPriceInfo(true);
        openInfoModal();
      },
    },
    {
      label: "Initial LTV",
      tooltip: "Loan-to-value ratio at the time of borrowing.",
      value: initialLTVForPopup,
      onClick: () => {
        setShowInitialLtvInfot(true);
        openInfoModal();
      },
    },
    {
      label: "Liquidation LTV",
      tooltip: "LTV at which liquidation is triggered.",
      value: liquidationLTVForPopup,
      onClick: () => {
        setShowLiqudationLtvInfo(true);
        openInfoModal();
      },
    },
    {
      label: "Margin Call LTV",
      tooltip: "LTV threshold that prompts a margin call.",
      value: marginCallLTVForPopup,
      onClick: () => {
        setShowMarginCallLtvInfo(true);
        openInfoModal();
      },
    },
  ];

  // Resolved accent colour with safe fallback
  const accentColor = btncolor || "#1976d2";

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ───────────────────────────────────────────────────── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(accentColor, 0.95)} 0%, ${alpha(accentColor, 0.72)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          {/* Icon badge */}
          <Box sx={heroIconBadge}>
            <AccountBalanceOutlinedIcon
              sx={{ fontSize: 28, color: "#fff" }}
            />
          </Box>

          {/* Title + subtitle + feature chips */}
          <Box sx={{ flex: 1 }}>
            <Typography sx={heroTitle}>
              {brokerBasicInfo.exchange} Crypto Loans
            </Typography>
            <Typography sx={heroSubtitle}>
              Borrow crypto assets. Repay any time. No transaction fees. No
              credit check required.
            </Typography>

            {/* Feature bullets */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
              {FEATURE_BULLETS.map((f) => (
                <Box
                  key={f}
                  sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                >
                  <CheckCircleIcon
                    sx={{ fontSize: 14, color: "rgba(255,255,255,0.9)" }}
                  />
                  <Typography
                    sx={{
                      fontSize: "0.78rem",
                      color: "rgba(255,255,255,0.88)",
                    }}
                  >
                    {f}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* "My Active Loans Overview" button – right side of hero */}
          <Box sx={{ flexShrink: 0, alignSelf: "center" }}>
            <Link
              to="/loan-overview"
              className="no-underline"
              style={{ border: "none" }}
            >
              <Button
                variant="outlined"
                size="small"
                sx={{
                  color: "#fff",
                  borderColor: "rgba(255,255,255,0.6)",
                  borderRadius: "10px",
                  fontWeight: 600,
                  fontSize: "0.8rem",
                  px: 2,
                  py: 0.85,
                  whiteSpace: "nowrap",
                  "&:hover": {
                    borderColor: "#fff",
                    backgroundColor: "rgba(255,255,255,0.12)",
                  },
                }}
              >
                My Active Loans Overview
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>

      {/* ── Loan Markets card ─────────────────────────────────────────────── */}
      <Box sx={mainCard}>
        {/* Card header */}
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            borderBottom: "1px solid rgba(125,125,125,0.15)",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1rem",
              color: "var(--text-color)",
              letterSpacing: "-0.01em",
            }}
          >
            Loan Markets
          </Typography>
        </Box>

        {/* Table */}
        <Box sx={{ p: { xs: 1.5, md: 2 } }}>
          <TableContainer component={Paper} elevation={0} sx={modernTableContainer}>
            <Table
              size="small"
              stickyHeader
              aria-label="loan markets table"
              sx={{ borderCollapse: "separate", borderSpacing: "0px 3px" }}
            >
              <TableHead>
                <TableRow sx={modernTableHeadRow}>
                  <TableCell sx={modernTableHeadCell}>
                    Loanable Assets
                  </TableCell>

                  <TableCell sx={modernTableHeadCell}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Box>
                        <Box>Flexible Rates</Box>
                        <Box
                          sx={{
                            fontSize: "0.68rem",
                            opacity: 0.65,
                            fontWeight: 400,
                            textTransform: "none",
                            letterSpacing: 0,
                          }}
                        >
                          Minute / Annualized Interest Rate
                        </Box>
                      </Box>
                      <IconButton
                        size="small"
                        onClick={() => setFlexibleExpanded(!isFlexibleExpanded)}
                        sx={{ color: "var(--text-color)", opacity: 0.6, p: 0.25 }}
                      >
                        {isFlexibleExpanded ? (
                          <ArrowLeftIcon fontSize="small" />
                        ) : (
                          <ArrowRightIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>

                  {isFlexibleExpanded && (
                    <>
                      <TableCell sx={modernTableHeadCell}>
                        Min Single Loan Amount (USD)
                      </TableCell>
                      <TableCell sx={modernTableHeadCell}>
                        Cumulative Borrow Limit (USD)
                      </TableCell>
                    </>
                  )}

                  <TableCell sx={modernTableHeadCell}>
                    <Box>
                      <Box>7 Days - Stable Rate</Box>
                      <Box
                        sx={{
                          fontSize: "0.68rem",
                          opacity: 0.65,
                          fontWeight: 400,
                          textTransform: "none",
                          letterSpacing: 0,
                        }}
                      >
                        Minute / Annualized Interest Rate
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell sx={modernTableHeadCell}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Box>
                        <Box>30 Days - Stable Rate</Box>
                        <Box
                          sx={{
                            fontSize: "0.68rem",
                            opacity: 0.65,
                            fontWeight: 400,
                            textTransform: "none",
                            letterSpacing: 0,
                          }}
                        >
                          Minute / Annualized Interest Rate
                        </Box>
                      </Box>
                      <IconButton
                        size="small"
                        onClick={() => set30DaysExpanded(!is30DaysExpanded)}
                        sx={{ color: "var(--text-color)", opacity: 0.6, p: 0.25 }}
                      >
                        {is30DaysExpanded ? (
                          <ArrowLeftIcon fontSize="small" />
                        ) : (
                          <ArrowRightIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>

                  {is30DaysExpanded && (
                    <>
                      <TableCell sx={modernTableHeadCell}>
                        Min Loan Amount (USD)
                      </TableCell>
                      <TableCell sx={modernTableHeadCell}>
                        Cumulative Borrow Limit (USD)
                      </TableCell>
                    </>
                  )}

                  <TableCell sx={modernTableHeadCell}>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loanAssets.map((l, index) => (
                  <TableRow key={index} sx={modernTableBodyRow}>
                    <TableCell sx={modernTableBodyCell}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <img
                          src={`${ASSETICONBASEURL}${l.loanAsset}.png`}
                          alt={l.loanAsset}
                          width="20"
                          height="20"
                          style={{ borderRadius: "50%" }}
                        />
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            color: "var(--text-color)",
                          }}
                        >
                          {l.loanAsset}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell sx={modernTableBodyCell}>
                      {l.flexibleRate
                        ? `${l.flexibleRate.interestRatePerMinute} / ${l.flexibleRate.annualizedInterestRate}`
                        : " - "}
                    </TableCell>

                    {isFlexibleExpanded && (
                      <>
                        <TableCell sx={modernTableBodyCell}>
                          {l.flexibleRate
                            ? l.flexibleRate.minLoanableAmount
                            : " - "}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {l.flexibleRate
                            ? l.flexibleRate.maxCumulativeBorrowAmountUSD
                            : " - "}
                        </TableCell>
                      </>
                    )}

                    <TableCell sx={modernTableBodyCell}>
                      {l.sevenDaysRate
                        ? `${l.sevenDaysRate.interestRatePerMinute} / ${l.sevenDaysRate.annualizedInterestRate}`
                        : " - "}
                    </TableCell>

                    <TableCell sx={modernTableBodyCell}>
                      {l.thirtyDaysRate
                        ? `${l.thirtyDaysRate.interestRatePerMinute} / ${l.thirtyDaysRate.annualizedInterestRate}`
                        : " - "}
                    </TableCell>

                    {is30DaysExpanded && (
                      <>
                        <TableCell sx={modernTableBodyCell}>
                          {l.thirtyDaysRate
                            ? l.thirtyDaysRate.minLoanableAmount
                            : " - "}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {l.thirtyDaysRate
                            ? l.thirtyDaysRate.maxCumulativeBorrowAmountUSD
                            : " - "}
                        </TableCell>
                      </>
                    )}

                    <TableCell sx={modernTableBodyCell}>
                      <ContainedButton
                        size="small"
                        variant="contained"
                        onClick={() => handleOpenBorrowModal(l)}
                      >
                        Borrow
                      </ContainedButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* ── Borrow Dialog ─────────────────────────────────────────────────── */}
      <Dialog
        open={borrowModalOpen}
        onClose={() => setBorrowModalOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          <Grid container alignItems="center">
            <Grid size={2} textAlign="right" />
            <Grid size={8} textAlign="center">
              <Typography variant="h6" fontWeight={700} sx={{ color: "var(--text-color)" }}>
                Borrow
              </Typography>
            </Grid>
            <Grid size={2} textAlign="right">
              <IconButton
                onClick={() => setBorrowModalOpen(false)}
                size="small"
                sx={{ color: "var(--text-color)" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers sx={{ px: 3, py: 2.5 }}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid size={12}>
              <FormControl fullWidth>
                <InputLabel>Loan Type</InputLabel>
                <Select
                  value={selectedLoanType}
                  onChange={(e) => {
                    renderDataOnBasisOfLoanType(e.target.value);
                    showHideMinimumLoanableAmount();
                  }}
                  label="Loan Type"
                >
                  <MenuItem value="">Select Loan Type</MenuItem>
                  <MenuItem value="1">
                    Flexible Rate - Use Earn Interest (Flexible) wallet assets
                    as collateral, use Spot Wallet as supply.
                  </MenuItem>
                  <MenuItem value="2">
                    7-day Stable Rate - Use spot wallet assets as collateral
                  </MenuItem>
                  <MenuItem value="3">
                    30-day Stable Rate - Use spot wallet assets as collateral
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Borrow Amount */}
          <Grid
            container
            spacing={2}
            sx={{ mb: 2 }}
            display="flex"
            justifyContent="start"
          >
            <Grid size={7}>
              <TextField
                fullWidth
                type="number"
                label="I want to borrow"
                placeholder="Enter Amount"
                value={loanAmount}
                onChange={(e) => setLoanAmount(e.target.value)}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onKeyUp={(e) =>
                  getLiquidationPrice(
                    "loan",
                    e.target.value,
                    selectedCurrencyForBorrow?.name,
                    selectedCurrencyForCollateral?.name
                  )
                }
                helperText={
                  loanAmount && showMinimumLoanableAmount ? (
                    <p
                      style={{ color: "#e82d2d" }}
                    >{`Minimum Loanable Amount: ${minLoanableAmount}`}</p>
                  ) : (
                    ""
                  )
                }
              />
            </Grid>
            <Grid size={5}>
              <OutlinedButton
                fullWidth
                variant="outlined"
                onClick={handleBorrowClick}
                endIcon={<ExpandMoreIcon />}
                sx={{
                  height: "55px",
                  borderRadius: 2,
                }}
              >
                <img
                  src={`${ASSETICONBASEURL}${selectedCurrencyForBorrow.name}.png`}
                  alt="icon"
                  width={20}
                  height={20}
                  style={{ marginRight: 8 }}
                />
                {selectedCurrencyForBorrow.name}
              </OutlinedButton>
              <Menu
                anchorEl={anchorBorrow}
                open={Boolean(anchorBorrow)}
                onClose={() => setAnchorBorrow(null)}
              >
                {currencies.sort().map((cur) => (
                  <MenuItem
                    key={cur}
                    onClick={() => {
                      handleBorrowCurrencySelect(cur);
                      handleSelectBorrowCurrency(cur);
                    }}
                  >
                    <img
                      src={`${ASSETICONBASEURL}${cur}.png`}
                      alt=""
                      width={20}
                      height={20}
                      style={{ marginRight: 8 }}
                    />
                    {cur}
                  </MenuItem>
                ))}
              </Menu>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 2 }}>
            {/* Collateral Section */}
            <Grid size={4} xs={12}>
              <TextField
                type="number"
                fullWidth
                label="Collateral"
                placeholder="Enter Amount"
                value={collateralAmount}
                onChange={(e) => setCollateralAmount(e.target.value)}
                onKeyUp={(e) =>
                  getLiquidationPrice(
                    "collateral",
                    e.target.value,
                    selectedCurrencyForBorrow?.name,
                    selectedCurrencyForCollateral?.name
                  )
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                helperText={
                  collateralAmount && showMinimumCollateralAmount ? (
                    <p
                      style={{ color: "#e82d2d" }}
                    >{`Minimum Collateral Amount: ${minimumCollateralAmountForPopup}`}</p>
                  ) : (
                    ""
                  )
                }
              />
            </Grid>
            <Grid size={3} xs={12}>
              <ContainedButton
                variant="contained"
                fullWidth
                onClick={() => getMaxCollateralAmount()}
                sx={{
                  height: "55px",
                  borderRadius: 2,
                }}
              >
                Max
              </ContainedButton>
            </Grid>
            <Grid size={5} xs={12}>
              <OutlinedButton
                fullWidth
                variant="outlined"
                onClick={handleCollateralClick}
                endIcon={<ExpandMoreIcon />}
                sx={{
                  height: "55px",
                  borderRadius: 2,
                }}
              >
                {selectedCurrencyForCollateral.name ? (
                  <>
                    <img
                      src={`${ASSETICONBASEURL}${selectedCurrencyForCollateral.name}.png`}
                      alt=""
                      width={20}
                      height={20}
                      style={{ marginRight: 8 }}
                    />
                    {selectedCurrencyForCollateral.name}
                  </>
                ) : (
                  "Select"
                )}
              </OutlinedButton>
              <Menu
                anchorEl={anchorCollateral}
                open={Boolean(anchorCollateral)}
                onClose={() => setAnchorCollateral(null)}
              >
                {currencies
                  .filter((cur) => cur !== selectedCurrencyForBorrow.name)
                  .filter((cur) => loanAssets.find((a) => a.loanAsset === cur)?.collateralAsset !== null)
                  .sort()
                  .map((cur, i) => (
                    <MenuItem
                      key={i}
                      onClick={() => {
                        handleCollateralCurrencySelect(cur);
                        handleSelectCollateralCurrency(cur);
                      }}
                    >
                      <img
                        src={`${ASSETICONBASEURL}${cur}.png`}
                        alt=""
                        width={20}
                        height={20}
                        style={{ marginRight: 8 }}
                      />
                      {cur}
                    </MenuItem>
                  ))}
              </Menu>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid size={12}>
              <Typography variant="caption" color="textSecondary">
                * Spot Wallet balance will be subscribed to Earn Interest
                (Flexible) first, then collateralized.
              </Typography>
            </Grid>
          </Grid>

          {/* Balance Type & Info */}
          <Box mt={4}>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel id="balance-type-label">
                Select Balance Type
              </InputLabel>
              <Select
                labelId="balance-type-label"
                value={balanceType}
                label="Select Balance Type"
                onChange={(e) => (
                  setBalanceType(e.target.value),
                  setSelectedBalanceType(e.target.value)
                )}
              >
                {showSpotWalletBalance && (
                  <MenuItem value="SPOT_WALLET">Spot Wallet</MenuItem>
                )}
                {showEarnWalletBalance && (
                  <MenuItem value="EARN_WALLET">Earn Wallet</MenuItem>
                )}
                {showTotalBalance && (
                  <MenuItem value="TOTAL_WALLET">Total Balance</MenuItem>
                )}
              </Select>
            </FormControl>

            {/* Dynamic Balances */}
            {showSpotWalletBalance && (
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Spot Wallet: <strong>{spotWalletBalanceForPopup}</strong>
              </Typography>
            )}
            {showEarnWalletBalance && (
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Earn Wallet: <strong>{earnWalletBalanceForPopup}</strong>
              </Typography>
            )}
            {showTotalBalance && (
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Total Balance: <strong>{totalBalanceForPopup}</strong>
              </Typography>
            )}

            {/* Loan Info Section */}
            <Box mt={3}>
              <Box
                sx={{
                  backgroundColor: "var(--body-color-less2)",
                  borderRadius: "12px",
                  border: "1px solid rgba(125,125,125,0.15)",
                  p: 2,
                }}
              >
                <Grid container spacing={2}>
                  {dataItems.map((item, index) => (
                    <Grid md={6} xs={12} key={index}>
                      <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.8rem",
                            color: "var(--text-color)",
                            opacity: 0.8,
                          }}
                        >
                          {item.label}
                        </Typography>
                        <Tooltip title={item.tooltip} onClick={item.onClick}>
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: 16,
                              cursor: "pointer",
                              color: accentColor,
                              transition: "0.3s",
                              "&:hover": { transform: "scale(1.2)" },
                            }}
                          />
                        </Tooltip>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: "var(--text-color)",
                            ml: 0.5,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>

            <FormControlLabel
              control={
                <Checkbox
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2">
                  I have read and agree to&nbsp;
                  <Link to={loanServiceAgreement} target="_blank">
                    {brokerBasicInfo.exchange} Loan Service Agreement
                  </Link>
                  &nbsp;and&nbsp;
                  <Link to={earnAgreement} target="_blank">
                    {brokerBasicInfo.exchange} Earn Interest Service Agreement
                  </Link>
                </Typography>
              }
              sx={{ mt: 3 }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ContainedButton
                variant="contained"
                sx={{
                  mt: 2,
                  borderRadius: 2,
                  py: 1,
                }}
                disabled={
                  !agreeTerms ||
                  !balanceType ||
                  !loanAmount ||
                  !collateralAmount ||
                  showMinimumLoanableAmount ||
                  showMinimumCollateralAmount
                }
                onClick={handleGetLoan}
              >
                Get Loan
              </ContainedButton>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ── Loan Info Dialog ──────────────────────────────────────────────── */}
      <Dialog
        open={loanInfoModal}
        onClose={() => setLoanInfoModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          <Grid container alignItems="center">
            <Grid size={3} />
            <Grid size={6}>
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: 700, color: "var(--text-color)" }}
              >
                Information
              </Typography>
            </Grid>
            <Grid size={3} textAlign="right">
              <IconButton
                onClick={() => resetAndCloseLoanInfoModal()}
                size="small"
                sx={{ color: "var(--text-color)" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers sx={{ px: 3, py: 2.5 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {showCollateralInfo && (
              <>
                <Typography sx={{ fontWeight: 600, color: "var(--text-color)" }}>
                  How is the amount of Collateral asset calculated?
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Collateral asset amount required = [Borrowed asset value (in
                  USD) + n days of accumulated interest in borrowing asset (in
                  USD)] / Initial LTV / Collateral asset value current market
                  price (in USD)
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n=1 (Flexible)</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n=7 (7 day stable rate)</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n=30 (30 day stable rate)</Typography>
              </>
            )}

            {showAnnualizedBorrowInterestRateInfo && (
              <>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  This value is set by {brokerBasicInfo.exchange} Loan
                  Underwriting team based on various market conditions.
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Interest amount is calculated by the compound interest method.
                  Interest accumulates after successful borrowing and is
                  calculated every minute. If the borrowing time is less than a
                  minute, it will also be calculated as 1 minute.
                </Typography>
                <Typography sx={{ fontWeight: 600, color: "var(--text-color)" }}>Compound interest calculation</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Compound interest = total amount of principal and interest in
                  future (or future value) minus principal amount at present (or
                  present value)
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>CI = [P (1 + i)^n] – P</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>= P [(1 + i)^n – 1]</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>CI = compound interest</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>P = principal</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  i = annualized interest rate / 365 / 24 / 60
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n = Loan age in minutes</Typography>
              </>
            )}

            {showAnnualizedInterestRateInfo && (
              <>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Net Annualized Interest rate is the net interest rate of
                  borrowing when the actual Interest Rate of borrowing is offset
                  by the interest earning rate of the collateralized assets.
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Net Annualized Interest Rate is displayed only when the "Loan
                  type" selected above is "Flexible Rate" loans...
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  The collateralized assets will continue to earn interest, which
                  helps to offset borrowing cost.
                </Typography>
                <Typography sx={{ fontWeight: 600, color: "var(--text-color)" }}>How this value is calculated?</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Net Annualized Interest Rate = Annualized Borrow Interest Rate -
                  (Annualized Collateral Interest Earning Rate/ Initial LTV)
                </Typography>
                <Typography sx={{ fontWeight: 600, color: "var(--text-color)" }}>Example:</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Annualized Borrow Interest Rate (for ETH) = 1.13%
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Annualized Interest Earning Rate in Flexible duration (for ETH)
                  in Earn Interest module = 0.75%
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>Initial LTV: </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Net Annualized Interest Rate = 1.13 - (0.75/0.7) = 0.06%
                </Typography>
              </>
            )}

            {showLiquidationRateInfo && (
              <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                Estimated Daily Interest Rate = Annualized Interest Rate / 365 /
                24
              </Typography>
            )}

            {showLiquidationPriceInfo && (
              <>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Liquidation Price of Collateral Asset (in USD) = [Borrowed Asset
                  Value (in USD) + n hour accumulated cumulative Interest in
                  borrowing asset Value (in USD)] / Collateral Amount of Borrowed
                  Asset (ETH) / Liquidation LTV
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n=1*24 (Flexible)</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n=7*24 (7 day stable rate)</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>n=30*24 (30 day stable rate)</Typography>
              </>
            )}

            {showInitialLtvInfo && (
              <>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  This value is set by {brokerBasicInfo.exchange} Loan
                  Underwriting team based on various market conditions.
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>LTV = Loan Value / Collateral Value</Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Initial LTV is the LTV value at the inception of the loan.
                </Typography>
              </>
            )}

            {showLiqudationLtvInfo && (
              <>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  This value is set by {brokerBasicInfo.exchange} Loan
                  Underwriting team based on various market conditions.
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  LTV = Loan Value + Interest / Collateral Value
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  Liquidation LTV is the LTV value at which the loan would be
                  liquidated.
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                  The system will automatically close your Collateral Asset to
                  repay the loan when Borrowed Asset + Accumulated Interest (USD
                  Value) / Liquidation Price of Collateral Asset (in USD) ≥
                  Liquidation LTV.
                </Typography>
              </>
            )}

            {showMarginCallLtvInfo && (
              <Typography sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.85 }}>
                Current Collateral Asset Price when Margin Call reminder is sent
                (in USD) [X] = [Borrowed Asset Value (in USD) + n day Accumulated
                Interest in borrowing asset Value (in USD)] / Collateral Amount of
                Borrowed Asset (ETH) / Margin LTV
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CryptoLoans;
